const TOPIC = Object.freeze({
  JEDI: {
    ID: "JEDI",
    DISPLAY_TITLE: "Justice, Equity, Diversity and Inclusion (JEDI)",
    DISPLAY_QUESTION:
      "Which of the following best describes your knowledge and skills as they relate to each of the four Justice, Equity, Diversity, and Inclusion (JEDI) areas?"
  },
  WRITING_COMMUNICATION: {
    ID: "WRITING_COMMUNICATION",
    DISPLAY_TITLE: "Writing and Communication",
    DISPLAY_QUESTION:
      "Which of the following best describes your knowledge and skills as they relate to each of the three Writing and Communications areas?"
  },
  MENTORING_FACILITATION_TEACHING: {
    ID: "MENTORING_FACILITATION_TEACHING",
    DISPLAY_TITLE: "Mentoring, Facilitation and Teaching",
    DISPLAY_QUESTION:
      "Which of the following best describes your knowledge and skills as they relate to each of the four Mentoring, Facilitation, and Teaching areas?"
  },
  LEADERSHIP_MANAGEMENT_PROFESSIONAL_DEVELOPMENT: {
    ID: "LEADERSHIP_MANAGEMENT_PROFESSIONAL_DEVELOPMENT",
    DISPLAY_TITLE: "Leadership, Management and Professional Development",
    DISPLAY_QUESTION:
      "Which of the following best describes your knowledge and skills as they relate to each of the seven Leadership, Management, and Professional Development areas?"
  },
  INTERPRETATION_USE_RESEARCH: {
    ID: "INTERPRETATION_USE_RESEARCH",
    DISPLAY_TITLE: "Interpretation and Use of Research",
    DISPLAY_QUESTION:
      "Which of the following best describes your knowledge and skills as they relate to each of the two Interpretation and Use of Research areas?"
  }
});

export default TOPIC;
